export const DefaultCard = {
    Id: '1',
    Type: '',
    Question: '',
    Answer: { Id: 1, Option: '', IsAnswer: true },
    Options: []
}